@if (!shows) {
  <div class="v-center">
    <app-spinner></app-spinner>
  </div>
} @else {
  @if (!this.followedShows?.length) {
    <div class="top">
      @if (!user && topics) {
        <tyt-animated-carousel class="carousel">
          @for (topic of topics; track topic) {
            <div class="topic-card" [responsiveBackgroundImage]="topic.backdrop_image">
              <h2>{{ topic.name }}</h2>
            </div>
          }
        </tyt-animated-carousel>
      }
      @if (user && shows) {
        <tyt-animated-carousel class="carousel">
          @for (show of shows; track show) {
            <div class="show-card">
              <div role="img" [responsiveBackgroundImage]="show.poster || show.tv_header_image"></div>
              <div role="img" [responsiveBackgroundImage]="show.logo_square"></div>
            </div>
          }
        </tyt-animated-carousel>
      }
      <div>
        <header>
          @if (user) {
            <h1>Follow Shows, Get Updates</h1>
            <h2>Your Progressive News feed is a click away.  Look for the Follow button:</h2>
            <div><tyt-follow-button style="pointer-events: none;"></tyt-follow-button></div>
          } @else {
            <h1>Shows that cover the topics you care about most</h1>
            <h2>Award Winning Progressive Shows that cover the Topics that matter most.</h2>
            <h3>Personalize Your Feed by picking topics and shows you are most interested in.</h3>
            <a mat-button role="button" routerLink="/signup" (click)="setAttribution()">Get Started</a>
          }
        </header>
        <img width="96" height="42" src="/assets/awards/streamy.svg" alt="Streamy Awards">
        <img width="96" height="54" src="/assets/awards/webby.svg" alt="Webby Awards">
        <img width="96" height="60" src="/assets/awards/aaa.svg" alt="American Advertising Awards">
        <img width="96" height="120" src="/assets/awards/shorty.svg" alt="Shorty Awards">
        <img src="/assets/awards/aha.svg" alt="American Humanist Association">
      </div>
    </div>
  }
  @for (shows of sections; track shows) {
    <div class="crumb">
      @if (shows === this.followedShows) {
        <span class="crumb__highlight">
          <mat-icon>star_outline</mat-icon>
          Followed Shows
        </span>
      } @else {
        <span class="icon-before">Shows</span>
      }
    </div>
    <div class="shows">
      @for (show of shows; track show) {
        <div class="show">
          <picture class="logo" responsive [src]="show.logo1_landscape || show.logo2_landscape"></picture>

          <div class="underlay"></div>

          <div class="actions">
            @if (user && show.is_followable) {
              <tyt-follow-button type="CMS::Show" [id]="show.id"></tyt-follow-button>
            }
            @if (canWatch(show)) {
              <a mat-button class="watch-button neutral sharp" [routerLink]="urlForShow(show)">
                <mat-icon>play_arrow</mat-icon>
                Watch
              </a>
            } @else {
              <tyt-join-button icon="add">
                Unlock
              </tyt-join-button>
            }
          </div>

          <a class="card-link" aria-hidden="true" [routerLink]="urlForShow(show)"></a>
          <div class="metadata">
            @if (show.is_premium) {
              <tyt-plus-tag></tyt-plus-tag>
            }
            <h2>{{ show.name }}</h2>
            @if (show.tune_in_live) {
              <div class="tune-in">
                Live {{ show.tune_in_live }}
                &nbsp;
              </div>
            }
            <div class="hosts">
              {{ hosts(show) }}
            </div>

            <div class="extended">
              <div class="description">
                {{ show.description }}
              </div>
              @if (show?.recent_topics?.length) {
                <div class="topics">
                  @for (topic of show?.recent_topics; track topic) {
                    <div class="topic">{{ topic.name }}</div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
}
